/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ month: NonNullable<unknown> }} Admin_Billing_Month_No_BillsInputs */



/**
* | output |
* | --- |
* | "No bills have closed in {month} yet — every partner is shown at zero." |
*
* @param {Admin_Billing_Month_No_BillsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_billing_month_no_bills = /** @type {((inputs: Admin_Billing_Month_No_BillsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Month_No_BillsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Im ${i?.month} wurde noch keine Rechnung abgeschlossen – alle Partner werden mit null angezeigt.`)
	return /** @type {LocalizedString} */ (`No bills have closed in ${i?.month} yet — every partner is shown at zero.`)
});